import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextMotion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTextMotion"><Path fillRule="evenodd" clipRule="evenodd" d="M21.9307 18.3848L22 18.5605V20H20V18.9375L18.4561 15H12.5439L11 18.9375V20H9V18.5605L9.06934 18.3848L14.3184 5H16.6816L21.9307 18.3848ZM13.3281 13H17.6719L15.5 7.46289L13.3281 13Z" fill="currentColor"/><Path d="M7 18H3V16H7V18Z" fill="currentColor"/><Path d="M9 13H2V11H9V13Z" fill="currentColor"/><Path d="M11 8H5V6H11V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTextMotion;
